import React from 'react';

import { CursorOption } from 'js/types';
import { ReactComponent as IconIndeterminate } from 'imgs/svg-icons/IconIndeterminate.svg';
import { ReactComponent as IconNoAnimation } from 'imgs/svg-icons/IconNoAnimation.svg';
import { NO_CURSOR_ID } from 'js/config/consts';

import { ChoiceButtonIcon } from '../ChoiceButtonIcon';

export const getCursorIcon = (cursor?: CursorOption) => {
  if (!cursor) {
    return <IconIndeterminate />;
  }

  if (cursor.id === NO_CURSOR_ID || !cursor.resources) {
    return <IconNoAnimation />;
  }

  return <ChoiceButtonIcon imgUrl={cursor.resources.thumbnail.url} isPen={cursor.group === 'pens'} />;
};
